
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"#224CA4","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.332 2.021a4.435 4.435 0 014.43 4.227l.005.208v.933a.75.75 0 01-1.494.102l-.006-.102v-.933a2.935 2.935 0 00-2.763-2.93l-.172-.005H6.455a2.935 2.935 0 00-2.929 2.763l-.005.172v11.13a2.935 2.935 0 002.762 2.93l.172.006h4.885a2.925 2.925 0 002.92-2.753l.006-.171v-.944a.75.75 0 011.493-.101l.007.101v.944a4.425 4.425 0 01-4.211 4.418l-.214.006H6.455a4.435 4.435 0 01-4.429-4.227l-.005-.209V6.457a4.435 4.435 0 014.226-4.43l.208-.005h4.875zm10.997 9.459a.748.748 0 01-.005 1.087l-2.913 2.902a.75.75 0 01-1.131-.98l.072-.083 1.64-1.635H9.77a.75.75 0 01-.102-1.493l.102-.007h10.225l-1.642-1.633a.75.75 0 01-.074-.977l.072-.084a.75.75 0 01.976-.075l.085.073 2.918 2.905z","fill":"inherit"}})])
          )
        }
      }
    